export default { resetInput, setOtherDescription }

function resetInput(role) {
  var resetEl = document.querySelector(`[data-role=${role}]`);

  if (resetEl) {
    resetEl.value = null;
  }
}

function setOtherDescription(value, quickCodes) {
  document.getElementById('other-description').classList.remove('hidden');

  const quickCodeForSelection = quickCodes.find(code => code.id == value);
  if (quickCodeForSelection !== undefined) {
    document.getElementById('fee_type_other_description').value = quickCodeForSelection.quickCode;
  } else {
    document.getElementById('fee_type_other_description').value = "";
  }
}
